var React = require('react');

function EmailCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#2F75EC","key":0}),React.createElement("path",{"d":"M12.5 14.375h15V25a.624.624 0 0 1-.625.625h-13.75A.624.624 0 0 1 12.5 25V14.375Z","stroke":"#fff","strokeWidth":"1.667","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M27.5 14.375 20 21.25l-7.5-6.875","stroke":"#fff","strokeWidth":"1.667","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

EmailCircle.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = EmailCircle;

EmailCircle.default = EmailCircle;
